import { Injectable } from '@angular/core';
import { Accord } from 'src/app/modules/shared/models/accord';
import { EngineeringPlanStore, MATPlanStore } from '../models/engineer-plan';
import { ActiveFilter } from '../models/filter';
import { Item } from 'src/app/modules/shared/dropdown/dropdown.models';

@Injectable({
  providedIn: 'root'
})
export class EngineeringPlanStoreService {

  accords: Accord[];
  activeFilter: ActiveFilter;
  engineerPlanCached: EngineeringPlanStore[];
  prevEngineerPlanCached: EngineeringPlanStore[];
  // defaultEngineerPlan: EngineeringPlan = null;
  matPlanCached: MATPlanStore[];
  prevMatPlanCached: MATPlanStore[];
  accountActionListItem: Item[] = [];
  constructor() {
    this.accords = [];
    this.engineerPlanCached = [];
    this.prevEngineerPlanCached = [];
    this.matPlanCached = [];
    this.prevMatPlanCached = [];
    this.activeFilter = {
      status: 'All',
      matStatus: 'Offshore'
    };
  }
}
